export const useExtractKeysFromBannedWords = (words: string[]) => {
  const bannedWordMap: { [key: string]: string[] } = {
    "say/said": ["say", "said", "says", "saying"],
    "see/saw": ["see", "sees", "seeing", "saw", "seen"],
    "go/went": ["go", "goes", "going", "went", "gone"],
    "get/got": ["get", "got", "gets", "getting"],
    "think/thought": ["think", "thinks", "thinking", "thought"],
    "eat/ate": ["eat", "eats", "eating", "ate", "eaten"],
    "come/came": ["come", "comes", "coming", "came"],
    "want/wanted": ["want", "wants", "wanting", "wanted"],
    good: ["good"],
    bad: ["bad"],
    nice: ["nice"],
    big: ["big"],
    little: ["little"],
    fun: ["fun"],
    small: ["small"],
    pretty: ["pretty"],
    happy: ["happy"],
    sad: ["sad"],
    "a lot": ["a lot"],
    "interesting": ["interesting"],
  };

  const matchedKeys: string[] = [];

  // Iterate through each key in the map
  for (const [key, bannedWords] of Object.entries(bannedWordMap)) {
    // Check if any word in the input array exists in this key's banned words
    const hasMatch = words.some((word) =>
      bannedWords.includes(word.toLowerCase())
    );

    if (hasMatch) {
      matchedKeys.push(key);
    }
  }

  return matchedKeys;
};
